import { render } from "./p-form.vue?vue&type=template&id=fcdc54de"
import script from "./p-form.vue?vue&type=script&lang=js"
export * from "./p-form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcdc54de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcdc54de', __exports__)) {
    api.reload('fcdc54de', __exports__)
  }
  
  module.hot.accept("./p-form.vue?vue&type=template&id=fcdc54de", () => {
    api.rerender('fcdc54de', render)
  })

}


export default __exports__